/**
 * Notice + assertions de migração das variáveis sensíveis do bundle.
 *
 * Roda uma única vez no boot do app (importado por App.tsx via side-effect).
 * Loga warnings se variáveis deprecadas ainda estão presentes no bundle,
 * para que o operador remova do EasyPanel antes do cutover final.
 *
 * Quando todas as três `REACT_APP_*` sensíveis sumirem do bundle e o app
 * continuar funcional (= todas as telas estão usando os proxies/services
 * novos), a tarefa `front-deep-remove-secrets` está formalmente concluída.
 */
const DEPRECATED_SECRETS = [
  "REACT_APP_SUPABASE_SERVICE_ROLE_KEY",
  "REACT_APP_SUPABASE_ANON_KEY",
  "REACT_APP_EVOLUTION_API_KEY",
  "REACT_APP_GOOGLE_CLIENT_SECRET",
  "REACT_APP_GOOGLE_CLIENT_ID",
  "REACT_APP_N8N_AUTH_HEADER",
] as const;

export function warnDeprecatedSecrets(): void {
  if (typeof process === "undefined" || !process.env) return;
  const present = DEPRECATED_SECRETS.filter(
    (k) => !!process.env[k] && process.env[k] !== ""
  );
  if (!present.length) return;
  // eslint-disable-next-line no-console
  console.warn(
    "[DelivAI v2] As seguintes variáveis sensíveis ainda estão no bundle do front e DEVEM ser removidas do EasyPanel:\n" +
      present.map((k) => "  - " + k).join("\n") +
      "\nElas foram substituídas por proxies/services no backend. Veja backend-delivai/docs/security.md §8 (bundle e proxies)."
  );
}
